import { useEffect, useState } from "react";
import { Flex, useBreakpointValue } from "@chakra-ui/react";

import DataTableSearch from "./DataTableSearch";
import DataTableTable from "./DataTableTable";
import DataTablePaginate from "./DataTablePaginate";
import DataTableCards from "./DataTableCards";

type ClienteData = {
	id: string;
	nome: string;
	doc: string;
	phone: string;
	cid: string;
}
interface DataTableClienteParams {
	data: ClienteData[];
}

const DataTableClient: React.FC<DataTableClienteParams> = ({
	data
}) => {
	const isWideVersion = useBreakpointValue({
		base: false,
		lg: true,
	});
	
	const [loading, setLoading] = useState(true);

	const [pesqClientes, setPesqClientes] = useState<ClienteData[]>(data);
	const [clientes, setClientes] = useState<ClienteData[]>(data);

	const [sort, setSort] = useState({ por: '', cres: true });

	const [controls, setControls] = useState({
		page: 1,
		perPage: 5,
		totalPage: Math.ceil(data.length / 5),
	});

	useEffect(() => {
		setClientes(data.slice(0, 5));
		setLoading(false);
	}, []);

	async function handleUpdateList(page: number, perPage: number, clients: ClienteData[]) {
		const auxPage = page - 1;
		const start = auxPage * perPage;
		const end = start + perPage;

		setClientes(clients.slice(start, end));
	};

	return (
		<Flex
			w="100%"
			flexDir="column"
		>
			<DataTableSearch
				clientes={data}
				setPesqClientes={setPesqClientes}
				controls={controls}
				setControls={setControls}
				handleUpdateList={handleUpdateList}
			/>

			{isWideVersion && (
				<DataTableTable
					clientes={clientes}
					pesqClientes={pesqClientes}
					sort={sort}
					setSort={setSort}
					controls={controls}
					handleUpdateList={handleUpdateList}
				/>
			)}

			{!isWideVersion && !loading &&(
				<DataTableCards clientes={clientes} />
			)}

			<DataTablePaginate
				cli_length={data.length}
				pesq_length={pesqClientes.length}
				pesqClientes={pesqClientes}
				controls={controls}
				setControls={setControls}
				handleUpdateList={handleUpdateList}
			/>
		</Flex>
	)
}

export default DataTableClient;